import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#E23764',
    },
    secondary: {
      light: '#45AAEF',
      main: '#3B8EDB',
      contrastText: '#FFFFFF',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

export default theme;



// WEBPACK FOOTER //
// ./src/sources/muiTheme.js